module.exports = __webpack_public_path__ + "media/images/eu2500-a63f91a174a5065cc455e47358a7eade.svg";